<template>
  <b-row class="filter1" id="filter1">
        <b-col cols="12" md="6" class="filter-all search-container border-b">
          <div class="search-style">
            <input class="search form-control" id="myInput" placeholder="Suchen" type="text" v-model="searchText" v-on:keyup.13="filterSearch(searchText)" />
            <button v-if="filter.search == ''" class="button-style" @click="filterSearch(searchText)" >
              <svg class="x-icon-search" height="20px" id="x-icon" style="enable-background:new 0 0 19.4 19.4;" version="1.1" viewbox="0 0 19.4 19.4" width="20px" x="0px" xml:space="preserve" y="0px"><title>x-filter</title><polygon points="19.4,1.4 18,0 9.7,8.3 1.4,0 0,1.4 8.3,9.7 0,18 1.4,19.4 9.7,11.1 18,19.4 19.4,18 11.1,9.7 "/></svg>
              <svg height="26px" id="search-icon" style="enable-background:new 0 0 25.7 25.4;" version="1.1" viewbox="0 0 25.7 25.4" width="27px" x="0px" xml:space="preserve" y="0px"><title>sarch-icon</title><path d="M14.2,0C7.9,0,2.7,5.2,2.7,11.5c0,2.7,1,5.3,2.6,7.2L0,24l1.4,1.4l5.3-5.3c2,1.8,4.6,2.8,7.5,2.8c6.3,0,11.5-5.2,11.5-11.5C25.7,5.2,20.5,0,14.2,0z M14.2,21c-5.2,0-9.5-4.3-9.5-9.5S9,2,14.2,2s9.5,4.3,9.5,9.5S19.4,21,14.2,21z"/></svg>
            </button>
            <button class="button-style" v-else-if="filter.search != ''" @click.stop="()=>{clearFilter('search'); searchText='';}">
              <!-- <svg xmlns="http://www.w3.org/2000/svg" style="enable-background:new 0 0 19.4 19.4; width: 26px; height: 26px;" version="1.1" viewBox="0 0 19.4 19.4" x="0px" xml:space="preserve" y="0px"><title>x-filter</title><polygon
          points="19.4,1.4 18,0 9.7,8.3 1.4,0 0,1.4 8.3,9.7 0,18 1.4,19.4 9.7,11.1 18,19.4 19.4,18 11.1,9.7 "/></svg> -->
            <svg class="x-close" width="21" height="21" xmlns="http://www.w3.org/2000/svg"><g stroke="#000" fill="none" fill-rule="evenodd" stroke-linecap="square"><path d="M1.559 1.559L20 20M19.441 1.559L1 20"/></g></svg>
            </button>


          </div>
        </b-col>
        <b-col cols="12" md="6" class="filter-all hide-mobile border-passive" id="schlagworte">
          <a class="filter-links link-schlagworte normallink" :class="{'text-red':filter.keywords.length}" href="#" @click="showHideSchlagworte()">Schlagworte <span
          v-if="filter.keywords.length" @click.stop="clearFilter('keywords')"><svg xmlns="http://www.w3.org/2000/svg" style="enable-background:new 0 0 19.4 19.4; fill: currentColor; width: 1.4rem; height: 1.4rem;" version="1.1" viewBox="0 0 19.4 19.4" x="0px" xml:space="preserve" y="0px"><title>x-filter</title><polygon
          points="19.4,1.4 18,0 9.7,8.3 1.4,0 0,1.4 8.3,9.7 0,18 1.4,19.4 9.7,11.1 18,19.4 19.4,18 11.1,9.7 "/></svg></span>
            <svg class="dropdown-icon" height="17px" id="dropdown-icon-schlagworte" style="enable-background:new 0 0 31.4 16.6;" version="1.1" viewbox="0 0 31.4 16.6" width="32px" x="0px" xml:space="preserve" y="0px"><title>dropdown</title><g id="Symbols"><g transform="translate(1.000000, -7.000000)"><polygon points="14.7,23.6 -1,8.4 0.4,7 14.7,20.8 29,7 30.4,8.4"/></g></g></svg>
          </a>
        </b-col>
      </b-row>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

const axios = require("axios");

export default {
  name: "filterRowOne",
  components: {
    //Navigation
  },
  props: {
    DropdownOpen: Boolean
  },
  data() {
    return {
      // entries: [],
      //MenuIsOpen: false
      // DropdownOpen: true
      searchText: '',
    };
  },
  created() {
    axios({
      url: "https://craft.femina-politica.de/api",
      method: "POST",
      // data: {
      //   query: `
      //         query {
      //            entries() {

      //           }
      //         }
      //       `,
      // },
    })
    // .then((result) => {
    //   let data = result.data.data.entries;
    //   console.log(data);

    //   // assign the fetched data 2 times, once for manipulation
    //   // once for reseting
    //   this.entries = data;
    //   this.entriesToManipulate = data;
    // });
  },
  computed:{
    ...mapGetters(['filter'])
  },
  methods: {
    ...mapActions(['filterSearch','filterKeyword','clearFilter']),
    showHideSchlagworte() {
      document.getElementById("schlagworteDropdown").classList.toggle("show");
      if (document.getElementById("autorDropdown").classList.contains("show")){
        document.getElementById("autorDropdown").classList.remove("show")
      }
      if (document.getElementById("ausgabeDropdown").classList.contains("show")){
        document.getElementById("ausgabeDropdown").classList.remove("show")
      }
      if (document.getElementById("rubrikenDropdown").classList.contains("show")){
        document.getElementById("rubrikenDropdown").classList.remove("show")
      }
      document.getElementById("schlagworte").classList.toggle("border-active");
      if (document.getElementById("rubriken").classList.contains("border-active")){
        document.getElementById("rubriken").classList.remove("border-active")
      }
      if (document.getElementById("autoren").classList.contains("border-active")){
        document.getElementById("autoren").classList.remove("border-active")
      }
      if (document.getElementById("ausgabe").classList.contains("border-active")){
        document.getElementById("ausgabe").classList.remove("border-active")
      }
      document.getElementById("dropdown-icon-schlagworte").classList.toggle("flip-dropdown");
      if (document.getElementById("dropdown-icon-ausgabe").classList.contains("flip-dropdown")){
        document.getElementById("dropdown-icon-ausgabe").classList.remove("flip-dropdown")
      }
      if (document.getElementById("dropdown-icon-autoren").classList.contains("flip-dropdown")){
        document.getElementById("dropdown-icon-autoren").classList.remove("flip-dropdown")
      }
      if (document.getElementById("dropdown-icon-rubriken").classList.contains("flip-dropdown")){
        document.getElementById("dropdown-icon-rubriken").classList.remove("flip-dropdown")
      }
    }
  }
};
</script>

<style lang="scss">
@import "../assets/css/master.scss";
</style>